import ScheduleTabs from './scheduleTabs';

export default ScheduleTabs;